import type { CommissionEditRequest } from "@/lib/commission.api";

export type CommissionEditQueueViewMode = "table" | "grid";

export const ALL_TYPE_FILTER_VALUE = "__all__";

export const COMMISSION_EDIT_QUEUE_GUIDE = [
  "Consultez les demandes de modification en attente.",
  "Approuvez ou rejetez avec un motif, l'historique reste visible dans les deux cas.",
];

export const FIELD_LABELS: Record<string, string> = {
  date: "Date",
  commissionAmount: "Montant",
  note: "Note",
  clientPartyId: "Client",
  referrerPartyId: "Référent",
  details: "Champs spécifiques",
};

export const STATUS_LABELS: Record<CommissionEditRequest["status"], string> = {
  pending: "En attente",
  approved: "Approuvée",
  rejected: "Refusée",
};

export const STATUS_CLASSES: Record<CommissionEditRequest["status"], string> = {
  pending: "bg-warning-bg text-warning-text border-warning-border",
  approved: "bg-success-bg text-success-text border-success-border",
  rejected: "bg-danger-bg text-danger-text border-danger-border",
};
